<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import { mapState, mapActions } from 'vuex'
  import SliderTile from '@/components/modules/occasions/OccasionsSliderTile'

  export default {
    name: 'OccasionsSlider',
    props: {
      moduleId: Number,
    },
    components: {
      SliderTile,
    },
    data() {
      return {
        feedLoaded: false,
        birthdaysLoaded: false,
        anniversariesLoaded: false,
      }
    },
    computed: {
      ...mapState('occasions', [
        'occasions',
        'birthdays',
        'anniversaries',
      ]),
    },
    created() {
      this.getFeed().then(data => { this.feedLoaded = true})
      this.getBirthdays({module_id: this.moduleId}).then(data => { this.birthdaysLoaded = true})
      this.getAnniversaries({module_id: this.moduleId}).then(data => { this.anniversariesLoaded = true})
    },
    methods: {
      ...mapActions('occasions', [
        'getFeed',
        'getAnniversaries',
        'getBirthdays',
      ]),
    },
  }
</script>
